import { useMemo, useState } from 'react';

function getValue(obj, key) {
  if (key === 'conversationIds') {
    return obj[key]?.length || 0;
  }
  if (key === 'lastUsed') {
    return new Date(obj[key]) || 0; // Convert `lastUsed` to a Date object
  }
  // Handle numeric fields for clinician data
  if (
    key === 'visits' ||
    key === 'timeSaved' ||
    key === 'visitsOnActiveDay' ||
    key === 'patientsSeen' ||
    key === 'fComplianceVisits' ||
    key === 'avgComplianceScore'
  ) {
    return Number(obj[key]) || 0;
  }
  return obj[key]?.toString().toLowerCase() || '';
}

export const useSortableData = (
  items,
  defaultSortKey = '',
  defaultDirection = 'asc',
) => {
  const [sortConfig, setSortConfig] = useState({
    key: defaultSortKey,
    direction: defaultDirection,
  });

  const sortedItems = useMemo(() => {
    if (!sortConfig.key) return items;

    return [...items].sort((a, b) => {
      const { key, direction } = sortConfig;

      const aValue = getValue(a, key);
      const bValue = getValue(b, key);

      if (aValue < bValue) return direction === 'asc' ? -1 : 1;
      if (aValue > bValue) return direction === 'asc' ? 1 : -1;
      return 0;
    });
  }, [items, sortConfig]);

  const handleSort = (key) => {
    setSortConfig((prevConfig) => ({
      key,
      direction:
        prevConfig.key === key && prevConfig.direction === 'asc'
          ? 'desc'
          : 'asc',
    }));
  };

  return { sortedItems, sortConfig, handleSort };
};
